import ToolkitTable from "components/Cards/Tables/ToolkitTable";

import { columnTextField } from "utils/tables-utils";

const TabelaMonitorInfracommerce = ({ dataTable }) => {
  const columnModel = [
    columnTextField(
      {
        dataField: "NumeroPedidoKSA",
        text: "N° Pedido KSA",
        align: "center",
        headerStyle: { width: 120 },
      },
      false
    ),
    columnTextField(
      {
        dataField: "NumeroPedidoIFC",
        text: "N° Pedido IFC",
        align: "center",
        headerStyle: { width: 130 },
      },
      false
    ),
    columnTextField(
      {
        dataField: "DataEmissaoFormat",
        text: "Data de Emissão",
        align: "center",
        headerStyle: { width: 130 },
      },
      false
    ),
    // columnTextField(
    //   {
    //     dataField: "UltimoStatuIFC",
    //     text: "Status IHub",
    //     align: "center",
    //     headerStyle: { width: 150 },
    //   },
    //   false
    // ),
    // columnTextField(
    //   {
    //     dataField: "UltimoStatusMLN",
    //     text: "Status Millenium",
    //     headerStyle: { width: 130 },
    //     align: "center",
    //   },
    //   false
    // ),
    columnTextField(
      {
        dataField: "DiasParado",
        text: "Dias",
        align: "center",
        headerStyle: { width: 120 },
      },
      false
    ),
    columnTextField(
      {
        dataField: "LogErro",
        text: "LOG Erro",
        align: "center",
        headerStyle: { width: 220 },
      },
      false
    ),
  ];

  return (
    <>
      <ToolkitTable
        searched={Boolean(dataTable)}
        keyField="NumeroPedidoKSA"
        dataTable={dataTable}
        columnModel={columnModel}
        pagination={{
          options: [25, 50, 100],
          defaultOption: 25,
          totalSize: dataTable?.length,
          showTotal: true,
        }}
        headerTitle="Pedidos Infracommerce"
        notFoundTitle="Sua pesquisa não encontrou pedidos correspondentes."
      />
    </>
  );
};

export default TabelaMonitorInfracommerce;
